import { Button } from 'react-bootstrap'
import { BsArrowUpRight } from 'react-icons/bs'
import '../containers/BlogMarquee.css'

const BlogMarquee = () => {
    return (
        <Button className='marquee-btn-whats-new' href={`${window.location.href}echoes-from-the-void/2026-07-18`} target='_blank' rel='noreferrer noopener'><BsArrowUpRight/> NEW BLOG POST: "Ethical Piracy"</Button>
    );
}

export default BlogMarquee;
